module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p5-44693277c0b67a58b63cdc00644da80c.png";